<template>
  <div id="gallery" class="gallery-wrap pb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Gallery Exhibition</span>
            <h2>Discover Your <span>Health</span> From Our Medical Clinic</h2>
          </div>
        </div>
      </div>
      <div class="gallery-item-wrap style3">
        <div
          class="gallery-card style5"
          v-for="gallery in galleries"
          :key="gallery.id"
        >
          <img :src="gallery.image" alt="Image" />
          <div class="gallery-info">
            <div class="gallery-info-left">
              <h3>
                <router-link to="/gallery-details">
                  {{ gallery.title }}
                </router-link>
              </h3>
              <span>{{ gallery.tag }}</span>
            </div>
            <div class="gallery-info-right">
              <router-link class="gallery-icon" to="/gallery-details">
                <i class="ri-add-line"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "GalleryExhibition",
  data: () => ({
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/marcas/1.jpg"),
        title: "Optometrist",
        tag: "Special Service",
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-26.jpg"),
        title: "Nefronia",
        tag: "Eye Care",
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-27.jpg"),
        title: "Cornea Check",
        tag: "Checkup",
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-28.jpg"),
        title: "Anestesia",
        tag: "Eye Care",
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-29.jpg"),
        title: "Laser Treatment",
        tag: "Special Service",
      },
      {
        id: 6,
        image: require("../../assets/images/gallery/gallery-30.jpg"),
        title: "Optometrist",
        tag: "Special Service",
      },
      {
        id: 7,
        image: require("../../assets/images/gallery/gallery-31.jpg"),
        title: "Plastic Surgery",
        tag: "Special Service",
      },
    ],
  }),
});
</script>